// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryAd1-cls1_tqK","cls2":"PodcastLibraryAd1-cls2_gFM PodcastLibraryAd1-cls1_tqK"};